const userPaidStatuses = ['USER_PAID', 'USER_PAID_TAKEAWAY', 'VOUCHER_ORDER_ACCEPTED'];

const checkIfUserPaid = (status) =>
  userPaidStatuses.some((userPaidStatus) => userPaidStatus === status);

export default checkIfUserPaid;
